module.exports = __webpack_public_path__ + "img/certificate.2b8ad681.png";